import React, { useState } from "react";
import client, { databases } from "../appwrite";
import { Teams, Account, ID } from "appwrite";
import {
  Box,
  Button,
  TextField,
  Typography,
  CircularProgress,
  Alert,
} from "@mui/material";

const teams = new Teams(client);
const account = new Account(client);

export default function CreateTeam() {
  const [teamName, setTeamName] = useState("");
  const [inviteEmail, setInviteEmail] = useState("");
  const [teamId, setTeamId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleCreateTeam = async () => {
    setLoading(true);
    setMessage("");
    try {
      // const user = await account.get(); // Note: must be a registered user to be here

      const newTeam = await teams.create(ID.unique(), teamName);
      setTeamId(newTeam.$id);
      setMessage(`Team "${newTeam.name}" created!`);
    } catch (err) {
      console.error(err);
      setMessage(`Error creating team: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleInvite = async () => {
    if (!teamId || !inviteEmail) {
      setMessage("Missing team ID or invite email.");
      return;
    }

    // Note:
    //      Use the url parameter to redirect the user from the invitation email to your app.
    //      After the user is redirected, use the Update Team Membership Status endpoint
    //      to allow the user to accept the invitation to the team

    // TODO how to handle unregistered users?

    const redirectUrl =
      process.env.NODE_ENV === "development"
        ? "http://localhost:3000/registered/confirm-team"
        : "https://sunnycodesapp.com/registered/confirm-team";

    try {
      const invite = await teams.createMembership(
        teamId,
        [], // roles
        inviteEmail,
        undefined, // userId (optional)
        undefined, // phone (optional)
        redirectUrl,
        undefined // name of new team member
      );
      console.log("invite: ", invite);

      setMessage(`Invite sent to ${inviteEmail}`);
    } catch (err) {
      console.error(err);
      setMessage(`Error sending invite: ${err.message}`);
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 400,
        mx: "auto",
        mt: 5,
        p: 3,
        borderRadius: 2,
        boxShadow: 3,
      }}
    >
      <Typography variant="h5" gutterBottom>
        Create a Team
      </Typography>

      <TextField
        fullWidth
        label="Team Name"
        value={teamName}
        onChange={(e) => setTeamName(e.target.value)}
        margin="normal"
      />

      <Button
        variant="contained"
        color="primary"
        onClick={handleCreateTeam}
        disabled={loading || !teamName}
        fullWidth
      >
        {loading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          "Create Team"
        )}
      </Button>

      {teamId && (
        <>
          <Typography variant="h6" mt={4}>
            Invite a Team Member
          </Typography>
          <TextField
            fullWidth
            type="email"
            label="Teammate Email"
            value={inviteEmail}
            onChange={(e) => setInviteEmail(e.target.value)}
            margin="normal"
          />
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleInvite}
            disabled={!inviteEmail}
            fullWidth
          >
            Send Invite
          </Button>
        </>
      )}

      {message && (
        <Alert
          severity={message.startsWith("Error") ? "error" : "success"}
          sx={{ mt: 3 }}
        >
          {message}
        </Alert>
      )}
    </Box>
  );
}
